export const staticResourceUrl = `${process.env.REACT_APP_BASE_URL}/static_resources`

export const API_BASE_URL = "http://localhost:8000"
export const ACCESS_TOKEN = "accessToken"
export const OAUTH2_REDIRECT_URI = "https://localhost:3000/oauth2/redirect"
// export const SSO_AUTH_URL = `${API_BASE_URL}/login/oauth2/code/keycloak?redirect_uri=${OAUTH2_REDIRECT_URI}`
export const SSO_AUTH_URL = `${API_BASE_URL}/oauth2/authorization/keycloak-gateway-client`